<template>
  <div class="chart">
    <div class="buttonText">
      <span>统计图表</span>
      <div class="addData" @click="exportMethod">导出数据</div>
    </div>
    <div class="allCard">
      <!-- <div class="card" v-for="(item,index) in items" :key="index"> -->
      <div class="card">
        <span class="question">1.您对我院皮微科室设施和卫生等是否让您觉得满意？</span>
        <div id="main" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">2.您对本次前台安排治疗的服务效率和服务态度是否满意？</span>
        <div id="main1" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">3. 您对本美容师的解释,交流,服务内容是否满意？</span>
        <div id="main2" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">4.您对本次戒带的咨询人员态度是否满意？</span>
        <div id="main3" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">5.您对本次治疗医生的诊疗技术和服务态度是否满意？</span>
        <div id="main4" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">6.您对本次治疗后注意事项是否已告知饼了解清楚？</span>
        <div id="main5" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card">
        <span class="question">7.感谢您百忙中给与如实评价，在我们的本次服务过程中，您认为我们哪些工作仍需改进提升，望提出宝贵意见</span>
        <div id="main6" style="width: 100%;height:300px;"></div>
      </div>
      <div class="card lastCard"></div>
      <div class="card lastCard"></div>
    </div>

    <!-- 点击柱子详情 -->
    <el-dialog :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="mobile" label="手机号"></el-table-column>
        <el-table-column property="createTime" label="提交时间"></el-table-column>
        <el-table-column label="操作" align="center" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">详情</el-button>
            <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </el-dialog>

    <!-- 查看详情 -->
    <el-dialog :visible.sync="dialogDetail" v-if="dialogDetail">
      <div class="formTitle">调查问卷</div>
      <div>
        <span class="formUser">用户:{{form.mobile}}</span>
        <span>提交时间:{{form.createTime}}</span>
      </div>
      <div class="formList">
        <el-form ref="form" :model="form" label-width="80px" label-position="top">
          <div v-for="(item,index) in subjects" :key="item.id">
            <el-form-item>
              <div :class="questionNumber==(index+1)?'number':''">{{item.label}}</div>
              <div class="rate">
                <span class="state">满意度</span>
                <el-rate disabled v-model="item.score" show-score text-color="#EA812B" :score-template="item.rate"></el-rate>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="">
            <div :class="questionNumber==6?'number':''">6.您对本次治疗后注意事项是否已告知饼了解清楚？</div>
            <el-radio-group v-model="form.radio6">
              <el-radio label="A">A 清楚</el-radio>
              <el-radio label="B">B 不清楚</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="">
            <div :class="questionNumber==7?'number':''">7.感谢您百忙中给与如实评价，在我们的本次服务过程中，您认为我们哪些工作仍需改进提升，望提出宝贵意见！</div>
            <el-input type="textarea" v-model="form.remark" autosize disabled></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gridData: [],
      dialogTableVisible: false,
      listIndex: '',
      filters: {
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
      },
      dialogDetail: false,
      form: {
        rate1: '',
      },
      subjects: [
        {
          label: '1.您对我院皮微科室设施和卫生等是否让您觉得满意？',
          subjectOrder: 1,
        },
        {
          label: '2.您对本次前台安排治疗的服务效率和服务态度是否满意？',
          subjectOrder: 2,
        },
        {
          label: '3.您对本美容师的解释,交流,服务内容是否满意？',
          subjectOrder: 3,
        },
        {
          label: '4.您对本次戒带的咨询人员态度是否满意？',
          subjectOrder: 4,
        },
        {
          label: '5.您对本次治疗医生的诊疗技术和服务态度是否满意？',
          subjectOrder: 5,
        },
      ],
      questionNumber: '',
      numQuery: 1,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      var that = this
      var data = {
        subjectOrder: this.handOrder,
        page: this.filters.pagination.page,
        size: this.filters.pagination.limit,
        remark: this.handRemark,
        answer: this.handAnswer,
        questionnaireType: 1,
        areaType: this.numQuery,
      }
      api.request("/questionnaire/findQuestionnairePage", data, function (res) {
        that.gridData = res.data.list
        this.filters.pagination.total = parseInt(res.data.total)
      })
    },
    initData(name, data, xData) {
      name.resize();
      // 绘制图表
      const option = {
        tooltip: {},
        xAxis: {
          data: xData,
          // data: ['A', 'B', 'C', 'D', 'E'],
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
        },
        yAxis: {
          show: false,
        },
        series: [{
          type: 'bar',
          data: data,
          barWidth: "24px",
          itemStyle: {
            normal: {
              //柱形图圆角，初始化效果
              barBorderRadius: [20, 20, 20, 20],
              //每个柱子的颜色即为colorList数组里的每一项，如果柱子数目多于colorList的长度，则柱子颜色循环使用该数组
              color: params => {
                //  colorList是每根柱子的颜色，一组是一个渐变
                var colorList = [
                  ['#4FB6E3', '#085283'],
                  ['#F38CDA', '#9152A0'],
                  ['#FF7DA5', '#BB0A26'],
                  ['#F8B963', '#F06B00'],
                  ['#93DFE1', '#018C8E'],
                ]
                var index = params.dataIndex
                // 柱子个数超过colorList设置的个数，循环使用
                if (index >= colorList.length) {
                  index = index - colorList.length
                }
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: colorList[index][0]
                }, {
                  offset: 1,
                  color: colorList[index][1]
                }])
              },
            },
          },
          label: {
            show: true,
            position: 'top',
            formatter: function (params) {
              return params.data[1] + "人";
            },
          },
          showBackground: true,
          backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            barBorderRadius: [20, 20, 20, 20],
          }
        }],
      };
      name.setOption(option)
    },
    handClick(listName, index, areaType) {
      console.log(areaType);
      var that = this
      listName.on('click', function (params) {
        console.log(params)
        // console.log(params.dataIndex)
        that.questionNumber = (index + 1)
        that.dialogTableVisible = true
        that.listIndex = params.value[0].split(' ')[0]
        if ((index + 1) == 7) {
          var data = {
            // subjectOrder: (index + 1),
            page: that.filters.pagination.page,
            size: that.filters.pagination.limit,
            remark: '',
            questionnaireType: 1,
            areaType: areaType,
          }
          if (that.listIndex == 'A') {
            data.remark = 'fill'
          } else if (that.listIndex == 'B') {
            data.remark = 'unfilled'
          }
        } else {
          var data = {
            subjectOrder: (index + 1),
            answer: that.listIndex,
            page: that.filters.pagination.page,
            size: that.filters.pagination.limit,
            remark: '',
            questionnaireType: 1,
            areaType: areaType,
          }
        }
        api.request("/questionnaire/findQuestionnairePage", data, function (res) {
          that.gridData = res.data.list
          that.filters.pagination.total = parseInt(res.data.total)
          that.handRemark = data.remark
          that.handAnswer = data.answer
          that.handOrder = data.subjectOrder
        })
        that.$forceUpdate()
      });
    },
    // 查看详情
    handleEdit(index, row) {
      this.dialogDetail = true
      var data = {
        id: row.id
      }
      var that = this
      api.request("/questionnaire/findQuestionnaireById", data, function (res) {
        // console.log(res.data)
        that.form = res.data
        that.subjects.forEach(ele => {
          that.form.questtionniareSubject.forEach(item => {
            if (ele.subjectOrder == item.subjectOrder) {
              ele.score = Number(item.score)
              ele.answer = item.answer
              // 选项满意度转换
              if (ele.answer == 'E') {
                ele.rate = '很差'
              } else if (ele.answer == 'D') {
                ele.rate = '较差'
              } else if (ele.answer == "C") {
                ele.rate = '一般'
              } else if (ele.answer == 'B') {
                ele.rate = '满意'
              } else if (ele.answer == 'A') {
                ele.rate = '超赞'
              }
              // 处理旧数据提交的分数为空的情况
              if (ele.score == 0) {
                if (ele.answer == 'E') {
                  ele.score = 1
                } else if (ele.answer == 'D') {
                  ele.score = 2
                } else if (ele.answer == "C") {
                  ele.score = 3
                } else if (ele.answer == 'B') {
                  ele.score = 4
                } else if (ele.answer == 'A') {
                  ele.score = 5
                }
              }
            }
            if (item.subjectOrder == 6) {
              that.form.radio6 = item.answer
            }
          });
        });

      })
    },
    // 删除操作
    handleDel(index, row) {
      var that = this
      this.$confirm('确定要删除当前数据吗？', '删除数据', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/questionnaire/deleteQuestionnaireById", {
            id: row.id
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              that.dialogTableVisible = false
              that.dialogDetail = false
              this.getData()
            } else {
              _g.toast("error", "删除失败")
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    transData(temp) {
      var arr = []
      for (var i = 0; i < temp.length; i++) {
        var initArr = []
        for (var j = 0; j < 2; j++) {
          if (j == 0) {
            initArr[0] = temp[i].value + '';
          } else if (j == 1) {
            initArr[1] = temp[i].answerSum + '';
          }
        }
        arr[i] = initArr
      }
      var temp = arr
      return temp
    },
    transList(dataArr) {
      dataArr.forEach((ele, index) => {
        if (ele.answer == 'A') {
          ele.value = 'A 超赞'
        }
        if (ele.answer == 'B') {
          ele.value = 'B 满意'
        }
        if (ele.answer == 'C') {
          ele.value = 'C 一般'
        }
        if (ele.answer == 'D') {
          ele.value = 'D 较差'
        }
        if (ele.answer == 'E') {
          ele.value = 'E 很差'
        }
      });
      return dataArr
    },
    transListOne(dataArr) {
      dataArr.forEach((ele, index) => {
        if (ele.answer == 'A') {
          ele.value = 'A 已告知'
        }
        if (ele.answer == 'B') {
          ele.value = 'B 未告知'
        }
      });
      return dataArr
    },
    transListTwo(dataArr) {
      dataArr.forEach((ele, index) => {
        if (ele.fill == 'fill') {
          ele.value = 'A 已填写'
        }
        if (ele.fill == 'unfilled') {
          ele.value = 'B 未填写'
        }
      });
      return dataArr
    },
    aaa(arr, num) {
      var rest = arr.some(item => {
        if (item.answer == num) {
          return true
        }
      })
      if (rest) {
      } else {
        arr.push({
          answer: num,
          answerSum: 0
        })
      }
    },
    exportMethod() {
      let exportUrl = axios.defaults.baseURL;
      var formData = new FormData();
      formData.append("configCode", 1)
      formData.append("questionnaireType", 1)
      formData.append("areaType", this.numQuery)
      this.$confirm("此操作将导出excel文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          axios
            .post(
              exportUrl + "questionnaire/toExcelQuestionnaireInfo", formData, {
                responseType: "blob",
              }
            )
            .then((res) => {
              const blob = new Blob([res.data], {
                type: "application/vnd.ms-excel",
              });
              // console.log(blob, '----------0990');
              const fileName = "调查问卷.xlsx";
              const linkNode = document.createElement("a");
              linkNode.download = fileName; //a标签的download属性规定下载文件的名称
              linkNode.style.display = "none";
              linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
              document.body.appendChild(linkNode);
              linkNode.click(); //模拟在按钮上的一次鼠标单击
              URL.revokeObjectURL(linkNode.href); // 释放URL 对象
              document.body.removeChild(linkNode);
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getData() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(document.getElementById('main'));
      this.myChart1 = this.$echarts.init(document.getElementById('main1'));
      this.myChart2 = this.$echarts.init(document.getElementById('main2'));
      this.myChart3 = this.$echarts.init(document.getElementById('main3'));
      this.myChart4 = this.$echarts.init(document.getElementById('main4'));
      this.myChart5 = this.$echarts.init(document.getElementById('main5'));
      this.myChart6 = this.$echarts.init(document.getElementById('main6'));
      var data = {
        questionnaireType: 1,
        configCode: 1,
        areaType: this.numQuery,
      }
      var that = this

      api.request("/questionnaire/findSubjectOrderExt", data, function (res) {
        //   第一题
        that.aaa(res.data[1], 'A')
        that.aaa(res.data[1], 'B')
        that.aaa(res.data[1], 'C')
        that.aaa(res.data[1], 'D')
        that.aaa(res.data[1], 'E')
        res.data[1].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr1 = that.transList(res.data[1])
        const newData1 = that.transData(newArr1)
        that.initData(that.myChart, newData1, ['A 超赞', 'B 满意', 'C 一般', 'D 较差', 'E 很差']);
        //   第二题
        that.aaa(res.data[2], 'A')
        that.aaa(res.data[2], 'B')
        that.aaa(res.data[2], 'C')
        that.aaa(res.data[2], 'D')
        that.aaa(res.data[2], 'E')
        res.data[2].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr2 = that.transList(res.data[2])
        const newData2 = that.transData(newArr2)
        that.initData(that.myChart1, newData2, ['A 超赞', 'B 满意', 'C 一般', 'D 较差', 'E 很差']);
        //   第三题
        that.aaa(res.data[3], 'A')
        that.aaa(res.data[3], 'B')
        that.aaa(res.data[3], 'C')
        that.aaa(res.data[3], 'D')
        that.aaa(res.data[3], 'E')
        res.data[3].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr3 = that.transList(res.data[3])
        const newData3 = that.transData(newArr3)
        that.initData(that.myChart2, newData3, ['A 超赞', 'B 满意', 'C 一般', 'D 较差', 'E 很差']);
        //   第四题
        that.aaa(res.data[4], 'A')
        that.aaa(res.data[4], 'B')
        that.aaa(res.data[4], 'C')
        that.aaa(res.data[4], 'D')
        that.aaa(res.data[4], 'E')
        res.data[4].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr4 = that.transList(res.data[4])
        const newData4 = that.transData(newArr4)
        that.initData(that.myChart3, newData4, ['A 超赞', 'B 满意', 'C 一般', 'D 较差', 'E 很差']);
        //   第五题
        that.aaa(res.data[5], 'A')
        that.aaa(res.data[5], 'B')
        that.aaa(res.data[5], 'C')
        that.aaa(res.data[5], 'D')
        that.aaa(res.data[5], 'E')
        res.data[5].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr5 = that.transList(res.data[5])
        const newData5 = that.transData(newArr5)
        that.initData(that.myChart4, newData5, ['A 超赞', 'B 满意', 'C 一般', 'D 较差', 'E 很差']);
        //   第六题
        that.aaa(res.data[6], 'A')
        that.aaa(res.data[6], 'B')
        that.aaa(res.data[6], 'C')
        that.aaa(res.data[6], 'D')
        res.data[6].sort(function (a, b) {
          return a.answer.localeCompare(b.answer)
        })
        var newArr6 = that.transListOne(res.data[6])
        const newData6 = that.transData(newArr6)
        that.initData(that.myChart5, newData6, ['A 已告知', 'B 未告知']);
        //   第七题
        var newArr7 = that.transListTwo(res.data[7])
        const newData7 = that.transData(newArr7)
        that.initData(that.myChart6, newData7, ['A 已填写', 'B 未填写']);
      });
      this.handClick(this.myChart, 0, this.numQuery)
      this.handClick(this.myChart1, 1, this.numQuery)
      this.handClick(this.myChart2, 2, this.numQuery)
      this.handClick(this.myChart3, 3, this.numQuery)
      this.handClick(this.myChart4, 4, this.numQuery)
      this.handClick(this.myChart5, 5, this.numQuery)
      this.handClick(this.myChart6, 6, this.numQuery)
    }
  },

}
</script>
<style scoped>
.allCard {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}
.card {
  width: 32%;
  height: 330px;
  background: linear-gradient(78deg, #fcfeff 0%, #f4f9ff 100%);
  box-shadow: 0px 2px 12px 0px rgba(65, 90, 99, 0.06);
  border-radius: 4px;
  border: 1px solid rgba(77, 118, 197, 0.59);
  padding: 15px;
  box-sizing: border-box;
  margin-top: 15px;
}
.question {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #626365;
}
.chart >>> .el-textarea.is-disabled .el-textarea__inner {
  background: #eff2f6;
  border-radius: 3px;
}
.chart >>> .el-input__inner {
  border: none;
}
.formList {
  background: linear-gradient(78deg, #fcfeff 0%, #f4f9ff 100%);
  box-shadow: 0px 2px 12px 0px rgba(65, 90, 99, 0.06);
  border-radius: 4px;
  border: 1px solid rgba(77, 118, 197, 0.59);
  padding: 0 28px;
  box-sizing: border-box;
  margin-top: 20px;
}
.formTitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #616266;
  margin-bottom: 20px;
}
.formUser {
  margin-right: 20px;
}
.lastCard {
  border: none;
  background: none;
}
.chart >>> .el-textarea.is-disabled .el-textarea__inner {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #616266;
}
.chart >>> .el-textarea.is-disabled .el-textarea__inner {
  border-color: #eff2f6;
}
.addData {
  width: 165px;
  height: 38px;
  background: #fdab55;
  border-radius: 3px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 38px;
  cursor: pointer;
}
.buttonText {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.number {
  color: red;
}
.rate {
  display: flex;
  align-items: center;
}
.state {
  margin-right: 15px;
  font-weight: bold;
}
</style>